module.exports = __webpack_public_path__ + "img/loader.935649ce.svg";